<template>
  <div class="area background">
    <div class="text">
      <h2>Select cropping window</h2>
      <h3>
        Select your cropping window size. Our model works best if the cropping
        rectangle covers the width of your actual ultrasound video (excluding
        vendor related paddings).
      </h3>
      <input
        ref="input"
        type="file"
        name="image"
        accept="image/*"
        @change="setImage"
      />
      <div class="content">
        <section class="cropper-area">
          <div class="img-cropper">
            <vue-cropper
              ref="cropper"
              :aspect-ratio="2"
              :src.sync="imgSrc"
              preview=".preview"
            />
          </div>
          <div class="preview-area">
            <p>x: {{ croppingWindow.x }}</p>
            <p>y: {{ croppingWindow.y }}</p>
            <p>width: {{ croppingWindow.width }}</p>
            <p>height: {{ croppingWindow.height }}</p>
          </div>
        </section>
      </div>
      <div>
        <button @click="$emit('increaseCurrentStep')" class="button-small">
          Set cropping window
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueCropper from "vue-cropperjs";
import "cropperjs/dist/cropper.css";
import $ from "jquery";
export default {
  name: "CroppingWindow",
  components: {
    VueCropper
  },
  props: [
    "userID",
    "region",
    "project",
    "videos",
    "croppingWindow",
    "croppingImage",
    "croppingImageIsLoaded",
    "predictionRate"
  ],
  data() {
    return {
      polling: null,
      imgSrc: this.croppingWindow.image,
      cropImg: "",
      predictionRateTemp: this.predictionRate
    };
  },
  computed: {},
  methods: {
    report_crop() {
      this.$gtag.event("crop_video", { method: "Google" });
    },
    pollData() {
      this.polling = setInterval(() => {
        this.updateCroppingWindow();
      }, 50);
    },
    updateImage() {
      return new Promise(resolve => {
        $.get(
          `https://${this.region}-${this.project}.cloudfunctions.net/get_sample_frame`,
          {
            user_ID: this.userID,
            filename: this.videos[0].name,
            frame_num: 1
          },
          response => {
            this.imgSrc = response;
            this.$refs.cropper.replace(response);
            this.croppingWindow.imageIsLoaded = true;
            this.croppingWindow.image = response;
          }
        );
      });
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
    },
    flipY() {
      const dom = this.$refs.flipY;
      let scale = dom.getAttribute("data-scale");
      scale = scale ? -scale : -1;
      this.$refs.cropper.scaleY(scale);
      dom.setAttribute("data-scale", scale);
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    updateCroppingWindow() {
      let data = this.$refs.cropper.getData();
      this.croppingWindow.x = Math.round(data.x) + 1;
      this.croppingWindow.y = Math.round(data.y);
      this.croppingWindow.width = Math.round(data.width) - 2;
      this.croppingWindow.height = Math.round(data.height);
    },
    setImage(e) {
      const file = e.target.files[0];
      if (file.type.indexOf("image/") === -1) {
        alert("Please select an image file");
        return;
      }
      if (typeof FileReader === "function") {
        const reader = new FileReader();
        reader.onload = event => {
          this.imgSrc = event.target.result;
          // rebuild cropperjs with the updated source
          this.$refs.cropper.replace(event.target.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Sorry, FileReader API not supported");
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.polling);
  },
  created() {
    this.report_crop();
    if (!this.croppingWindow.imageIsLoaded) {
      this.updateImage();
    }
    this.pollData();
  }
};
</script>

<style scoped>
@import "../../assets/css/styling.css";

body {
  font-family: Arial, Helvetica, sans-serif;
  width: 1024px;
  margin: 0 auto;
}
input[type="file"] {
  display: none;
}
.header h2 {
  margin: 0;
}
.header a {
  text-decoration: none;
  color: black;
}
.content {
  padding-top: 10px;
  display: flex;
  justify-content: space-between;
}
.cropper-area {
  min-width: 53vh;
  max-width: 50vw;
  margin-top: 30px;
}
.actions a {
  display: inline-block;
  padding: 5px 15px;
  background: #c8c8c8;
  color: white;
  text-decoration: none;
  border-radius: 3px;
  margin-right: 1rem;
  margin-bottom: 1rem;
}
textarea {
  width: 100%;
  height: 100px;
}
.preview-area {
  margin-top: 3vh;
  width: 30vw;
}
.preview-area p {
  padding-right: 5%;
  padding-left: 4%;
  margin: 0 0 1rem;
  font-size: 13pt;
  font-family: "Helvetica", serif;
  display: inline-block;
  color: #666;
}
.cropped-image img {
  max-width: 100%;
}

ul {
  font-size: 15pt;
  list-style-type: square;
  padding-top: 0;
}

li {
}
</style>
